/**
 * @requires HBS
 */

(function() {
	/**
	 * @exports DKA.main
	 */
	let module = {};

	/**
	 * Global init code for the whole application
	 */
	module.init = () => {
		var ua = window.navigator.userAgent;
	    var msie = ua.indexOf("MSIE ");
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
		{
			console.log('IE');
		}
		else  // If another browser, return 0
		{
			console.log('other browser');
			module.aos();
		}
		
		module.accordion();
		module.setupCarousel();
		module.setupMobileNav();
		module.parallax();
		// module.splitzies();
		module.matchHeight();
		module.initTooltip();
		module.initSmoothScroll();

	};

	module.initSmoothScroll = function () {
		var scroll = new SmoothScroll('a[href*="#"]');
	}

	module.initTooltip = function () {
		var tippyItem = document.querySelector('.js-tippy-item');
    	if (tippyItem){   
			tippy('[data-tippy-content]'), {
				trigger: 'mouseenter click focus'
			};
		}
	}

	module.aos = function () {
 		AOS.init({ 
 			offset: 100, 
 			duration: 500, 
 			easing:"ease-out-quad", 
 			once:!0 }); 
 		window.addEventListener('load', AOS.refresh);
	};

	module.matchHeight = function () {
		// Running the function .05s after page load to prevent calculating
		// height before objects are fully rendered
		setTimeout(function() {
			setHeight();
		}, 50);

		// Running function on window resize
		window.addEventListener('resize', function() {
			// If window is greater than 540px set the height, otherwise
			// remove the any set heights
			if (window.innerWidth > 540) {
				setHeight();
			} else {
				removeHeight();
			}
		});

		function setHeight() {
			// Get all objects with the 'js-matchHeight' class
			var objects = document.getElementsByClassName('js-matchHeight');

			var arr = [];
			// Loop through all objects with the 'js-matchHeight' class
			for (var i = 0; i < objects.length; i++) {
				// If they have any inline styles, remove them
				if (objects[i].hasAttribute('style')) {
					objects[i].removeAttribute('style');
				}

				// Get the attribute 'data-height' from each object and push it
				// into an array
				var attr = objects[i].getAttribute('data-height');
				arr.push(attr);
			}

			

			function removeDuplicates(data) {
				// Filter an array and remove duplicate values
				return data.filter((value, index) => data.indexOf(value) === index);
			}

			// Set the array 'arr' to 'arr' with no duplicates to get the data-attributes
			// of each matchHeight group
			arr = removeDuplicates(arr);

			// Loop through each matchHeight group
			for (i = 0; i < arr.length; i++) {
				var height = 0;
				// Loop through all objects with the 'js-matchHeight' class
				for (var j = 0; j < objects.length; j++) {
					// If they have the same data-height attribute as the group
					if (objects[j].getAttribute('data-height') == arr[i]) {
						// If their height is larger that the 'height' variable
						if (height < objects[j].clientHeight) {
							// Set the 'height' variable equal to that object's height
							height = objects[j].clientHeight;
						}
					}
				}

				// Loop through all objects with the 'js-matchHeight' class
				for (j = 0; j < objects.length; j++) {
					// If they have the same data-height attribute as the group
					if (objects[j].getAttribute('data-height') == arr[i]) {
						// Set their height equal to the 'height' variable
						objects[j].style.height = height + 'px';
					}
				}
			}
		}

		function removeHeight() {
			var objects = document.getElementsByClassName('js-matchHeight');

			for (var i = 0; i < objects.length; i++) {
				// If they have any inline styles, remove them
				if (objects[i].hasAttribute('style')) {
					objects[i].removeAttribute('style');
				}
			}
		}
	}

	module.accordion = function () {
		var buttons = document.getElementsByClassName('js-accordion-trigger');

		var changeSign = function() {
			var clickedSign = this.getElementsByClassName('js-accordion-sign')[0];
			var allSigns = document.getElementsByClassName('js-accordion-sign');
			var isFAQsPage = false;

			// setup GTM for FAQ module only
			if ( (window.location.href.indexOf("support") > -1) && (document.getElementById('faqs')!=null) ) {
				isFAQsPage = true;
				window.dataLayer = window.dataLayer || [];
			}

			if (clickedSign.classList.contains('collapsed')) {
				for (var n = 0; n < allSigns.length; n++) {
					if (!allSigns[n].classList.contains('collapsed')) {
						allSigns[n].classList.add('collapsed');
					}
					clickedSign.classList.remove('collapsed');
				}
				
				// GTM Tracking for FAQs expand event
				if ( isFAQsPage === true ) {
					window.dataLayer.push({
						'clickText' : clickedSign.parentNode.innerText, //Text of the FAQ
						'event' : 'faq_expanded'
					});
			    }
				
			} else {

				clickedSign.classList.add('collapsed');				

				// GTM Tracking for FAQs close event
				if ( isFAQsPage === true ) {
					window.dataLayer.push({
						'clickText' : clickedSign.parentNode.innerText, //Insert the text of the FAQ
						'event' : 'faq_collapsed'
					});
			    }
			}
		}

		for (var i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener('click', changeSign, false);
		}
	};

	module.setupCarousel = () => {
		var mySwiper = new Swiper('.js-swiper-slider', {
			// Optional parameters
			loop: true,
			slidesPerView: 1,
			speed: 1000,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			centeredSlides: true,
			effect: 'slide',
		  
			// If we need pagination
			pagination: {
			  el: '.swiper-pagination',
			},
		  
			// Navigation arrows
			navigation: {
			  nextEl: '.swiper-button-next',
			  prevEl: '.swiper-button-prev',
			},
		})
	};

	module.setupMobileNav = () => {

		let mobileNavTrigger = document.getElementById('mobileNavTrigger');
		let headerWrapper = document.getElementById('headerWrapper');
		
		if (!mobileNavTrigger) return false;
		mobileNavTrigger.addEventListener('click', (event) => {

			if ( mobileNavTrigger.classList.contains('icon-hamburger') ) {
				mobileNavTrigger.classList.remove('icon-hamburger');
				mobileNavTrigger.classList.add('icon-close');
			} else {
				mobileNavTrigger.classList.remove('icon-close');
				mobileNavTrigger.classList.add('icon-hamburger');
			}

			if ( headerWrapper.classList.contains('header__wrapper--active') ) {
				headerWrapper.classList.remove('header__wrapper--active');
				document.body.classList.remove('state-fixed');
				
			} else {
				headerWrapper.classList.add('header__wrapper--active');
				document.body.classList.add('state-fixed');
				
			}
		});
	};

	module.parallax = () => {
		var image = document.getElementsByClassName('js-parallax');
		new simpleParallax(image, {
			// scale: 1.5 
		});
	}

	module.splitzies = () => {
		//only runs for ie11
		let splitzies = document.querySelectorAll('.js-splitzies');
		if(!document.querySelector('.ie11') && !splitzies.length) {
			return;
		}

		let splitziesArray = [];
		let objectfitProperty;
		let objectfitPosition;

		splitzies.forEach((splitzie) => {
			splitziesArray.push(splitzie);
			let img = splitzie.querySelector('.splitzies__img');

			if(img){			
				objectfitProperty = img.getAttribute('data-object-fit');
				objectfitPosition = img.getAttribute('data-object-position');

				let removeExistingPolyfillProperties = () => {
					img.removeAttribute('data-object-fit');
					img.removeAttribute('data-object-position');
					img.removeAttribute('style');
					img.parentElement.classList.remove('object-fit-polyfill');
					img.parentElement.removeAttribute('style');
				};

				if( splitzie.classList.contains('splitzies--overflow-true') || splitzie.querySelector('.splitzies__container--contained') ) {
					removeExistingPolyfillProperties()
				}
			}
			
			let classes = Array.prototype.slice.call(splitzie.classList);

			if(window.outerWidth <= 991 &&
				(splitzie.querySelector('.splitzies__container--full-width') &&
				classes.findIndex(element => element.includes("short")) === -1) &&
				img.hasAttribute('data-object-fit')) {
				removeExistingPolyfillProperties()
			}
		});

		window.addEventListener('resize', () => {
			splitziesArray.forEach((splitzie) => {
				let img = splitzie.querySelector('.splitzies__img');
				let classes = Array.prototype.slice.call(splitzie.classList);
				if(window.outerWidth <= 991 && (splitzie.querySelector('.splitzies__container--full-width') &&
					classes.findIndex(element => element.includes("short")) === -1) &&
					img.hasAttribute('data-object-fit')) {
						img.removeAttribute('data-object-fit');
						img.removeAttribute('data-object-position');
						img.removeAttribute('style');
						img.parentElement.classList.remove('object-fit-polyfill');
						img.parentElement.removeAttribute('style');
				} else if(window.outerWidth > 991 &&
					(splitzie.querySelector('.splitzies__container--full-width') &&
					classes.findIndex(element => element.includes("short")) === -1) &&
					!img.hasAttribute('data-object-fit')) {
						img.setAttribute('data-object-fit', objectfitProperty);
						img.setAttribute('data-object-position', objectfitPosition);
						objectFitPolyfill();
				}
			});
		});
	};

	var docReady = function docReady(callback) {
		// in case the document is already rendered
		if (document.readyState !== 'loading') {
			callback();
		} else if (document.addEventListener) {
		// modern browsers
			document.addEventListener('DOMContentLoaded', callback);
		} else {
		// IE <= 8
			document.attachEvent('onreadystatechange', function () {
				if (document.readyState === 'complete') callback();
			});
		}
	};

	docReady(() => {
		module.init();
		//HBS.initPage();
	});

	HBS.namespace('DKA.main', module);
}());